import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

const BTN_HALF = 18; // half of 36px button height

export const BackToTop = () => {
  const [visible, setVisible] = useState(false);
  const [bottom, setBottom] = useState(24);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
      const bar = document.getElementById("footer-made-in");
      if (bar) {
        const r = bar.getBoundingClientRect();
        const vh = window.innerHeight;
        if (r.top < vh) {
          // "Made in New York" line is in view — center button vertically on it
          const lineCenter = r.top + r.height / 2;
          setBottom(Math.max(vh - lineCenter - BTN_HALF, 24));
        } else {
          setBottom(24);
        }
      }
    };
    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onScroll);
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      data-testid="back-to-top"
      aria-label="Back to top"
      title="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      style={{ bottom: `${bottom}px` }}
      className="fixed right-6 z-40 h-9 w-9 rounded-full bg-brand-yellow hover:bg-brand-yellowhover text-brand-dark flex items-center justify-center shadow-[0_6px_18px_rgba(250,204,21,0.4),0_2px_6px_rgba(0,0,0,0.15)] transition-all duration-200 hover:-translate-y-0.5"
    >
      <ChevronUp size={18} strokeWidth={2.5} />
    </button>
  );
};
